import { AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechForm } from "@agtech/web/components/Forms/AgTechForm";
import { AgTechFormTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextControl";
import { AgTechFormRow } from "@agtech/web/components/Forms/Layout/AgTechFormRow";
import { useFormContext } from "@agtech/core/forms/AgTechFormContext";
import { DefaultDocumentHeaderConfiguration, DocumentHeaderConfiguration } from "@sales/data/operation/SaleDataOperation";
import { useOperationDataUpdateDocumentConfigurationAction } from "@sales/data/operation/SaleDataOperationActions";
import { useRef } from "react";

export type DocumentConfigurationFormProps = {
    config?: DocumentHeaderConfiguration
};

const DocumentHeaderConfigurationForm = (props: DocumentConfigurationFormProps) => {

    var configData = {
        ...DefaultDocumentHeaderConfiguration,
        ...props.config
    };

    let invoiceConfigurationSubmission = useOperationDataUpdateDocumentConfigurationAction();
    let submitButton = useRef<{ click: () => Promise<void> }>({ click: async () => {} });

    return (
        <AgTechForm
            structure={{
                header: {
                    title: 'Document header configuration',
                    content: () => <DocumentHeaderSaveButton onSave={() => submitButton.current?.click()} />
                },
                submitButton: submitButton
            }}
            initialFormData={configData}
            action={{
                action: invoiceConfigurationSubmission,
                getActionData: d => d
            }}
        >
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Address"
                    focused={true}
                    value={entity => entity.addressOverride ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        addressOverride: val
                    })}
                />
            </AgTechFormRow>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="City"
                    value={entity => entity.addressCityOverride ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        addressCityOverride: val
                    })}
                />
                <AgTechFormTextControl
                    entityType={configData}
                    caption="State"
                    value={entity => entity.addressStateOverride ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        addressStateOverride: val
                    })}
                />
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Zip"
                    value={entity => entity.addressZipOverride ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        addressZipOverride: val
                    })}
                />
            </AgTechFormRow>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Post-Address"
                    value={entity => entity.postAddressLine ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        postAddressLine: val
                    })}
                />
            </AgTechFormRow>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Pre-Address"
                    value={entity => entity.preAddressLine ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        preAddressLine: val
                    })}
                />
            </AgTechFormRow>
        </AgTechForm>
    )
}

const DocumentHeaderSaveButton = (props: { onSave: () => void }) => {
    let { isDirty } = useFormContext();

    return (
        <AgTechButton
            text='Save'
            icon='fas fa-save'
            classes='button-highlight px-4'
            disableIf={!isDirty}
            action={props.onSave}
        />
    );
}

export default DocumentHeaderConfigurationForm